import { Inject, Injectable, NgZone } from '@angular/core';
import { BlockScrollStrategy, ScrollDispatcher, ScrollStrategyOptions } from '@angular/cdk/overlay';

import { ElLayoutScrollService } from '../../../services/scroll.service';
import { EL_DOCUMENT } from '../../../theme.options';
import { ElViewportRulerAdapter } from './viewport-ruler-adapter';


/**
 * Overrides default block scroll strategy because default strategy blocks scrolling on the body only.
 * But Endlessjs has its own scrollable container - el-layout. So, we need to block scrolling in it to.
 * */
@Injectable()
export class ElBlockScrollStrategyAdapter extends BlockScrollStrategy {
  constructor(@Inject(EL_DOCUMENT) document: any,
              viewportRuler: ElViewportRulerAdapter,
              protected scrollService: ElLayoutScrollService) {
    super(viewportRuler, document);
  }

  enable() {
    super.enable();
    this.scrollService.scrollable(false);
  }

  disable() {
    super.disable();
    this.scrollService.scrollable(true);
  }
}

export class ElScrollStrategyOptions extends ScrollStrategyOptions {
  constructor(protected scrollService: ElLayoutScrollService,
              protected scrollDispatcher: ScrollDispatcher,
              protected viewportRuler: ElViewportRulerAdapter,
              protected ngZone: NgZone,
              @Inject(EL_DOCUMENT) protected document) {
    super(scrollDispatcher, viewportRuler, ngZone, document);
  }

  block = () => new ElBlockScrollStrategyAdapter(this.document, this.viewportRuler, this.scrollService);
}
